import PropTypes from 'prop-types';

import { cn } from '#/lib/utils';
import { Switch as ShadcnSwitch } from '#/modules/commonComponents/shadcn/ui/switch';

/** ERP 樣式掛點（換皮只改此常數，禁止改 vendor） */
const SWITCH_ERP_CLASS = '';

const Switch = ({ className, ...props }) => (
  <ShadcnSwitch
    className={cn(SWITCH_ERP_CLASS, className)}
    {...props}
  />
);

Switch.propTypes = {
  className: PropTypes.string,
};

export { Switch };
